import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import PolicyTemplateTable from "./PolicyTemplateTable";

const PolicyTemplatesModal = (props) => {

	const handleClose = () => {
		props.onClose()
	};
	
	return (
		<Dialog
			open={props.open? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="lg"
		>
			<DialogTitle id="alert-dialog-title">
				Policy Templates
			</DialogTitle>
			<DialogContent>
				<PolicyTemplateTable/>
			</DialogContent>
		</Dialog>
	);

}

export default PolicyTemplatesModal;